import { computed, observable } from 'mobx';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import { jumpPage } from '@src/utils/common-util';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { MECHA_INFO } from './config';
import styles from './index.less';
import calcBtnPosition from './utils/calc-btn-position';

class FifthPageStore extends BaseStore {
  @observable activeIndex = 0;
  @observable mechaList = [];

  @computed
  get mechaId() {
    this.updateCompleted = false;
    return MECHA_INFO[this.activeIndex].id;
  }

  @computed
  get mechaInfo() {
    return this.mechaList.find(i => i.mecha_id === this.mechaId) || {};
  }

  @computed
  get btnRectInfo() {
    return MECHA_INFO[this.activeIndex].btnRectInfo;
  }

  indicatorSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      initialSlide: this.activeIndex,
      direction: 'horizontal',
      spaceBetween: 5,
      slidesPerView: 4,
      slideToClickedSlide: true,
      centerInsufficientSlides: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      allowTouchMove: false
    }
  });

  lastMoveX = 0;
  updateCompleted = false;
  updateDetailBtnPosition = ({ btnRectInfo, id }) => {
    if (this.updateCompleted) {
      return;
    }
    this.updateCompleted = true;
    btnRectInfo = calcBtnPosition(btnRectInfo);
    document.querySelectorAll(`.${styles.installationPartRoot} [data-mecha-id=${id}]`).forEach(item => {
      item.style = `${item.style.cssText} width: ${btnRectInfo?.width}px; height: ${btnRectInfo?.height}px; top: ${btnRectInfo?.top}px; left: ${
        btnRectInfo?.left
      }px`;
    });
  };
  slidePrev = () => {
    let nextIndex = this.activeIndex - 1;
    if (nextIndex < 0) {
      nextIndex = MECHA_INFO.length - 1;
    }
    const mecha = MECHA_INFO[nextIndex];
    this.updateDetailBtnPosition(mecha);
  };
  slideNext = () => {
    let nextIndex = this.activeIndex + 1;
    if (nextIndex > MECHA_INFO.length - 1) {
      nextIndex = 0;
    }
    const mecha = MECHA_INFO[nextIndex];
    this.updateDetailBtnPosition(mecha);
  };
  pageSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      on: {
        init: () => {
          this.updateDetailBtnPosition(MECHA_INFO[0]);
          this.updateCompleted = false;
        },
        touchStart: ev => {
          this.lastMoveX = ev.clientX;
        },
        sliderMove: ev => {
          const { clientX } = ev;
          if (clientX < this.lastMoveX) {
            this.slideNext();
          } else if (clientX > this.lastMoveX) {
            this.slidePrev();
          }
          this.lastMoveX = clientX;
        }
      },
      allowTouchMove: MECHA_INFO.length > 1
    },
    onSlideChange: realIndex => {
      this.updateDetailBtnPosition(MECHA_INFO[realIndex]);
      this.updateCompleted = false;

      this.activeIndex = realIndex;
      this.indicatorSwiperStore.onChange(this.activeIndex - 1);
    }
  });

  toSlide = mechaId => {
    const idx = MECHA_INFO.findIndex(i => i.id === mechaId);
    idx !== void 0 && this.pageSwiperStore.onChange(+idx);
  };

  toSlideWithIndex = index => {
    this.activeIndex = index;
    this.pageSwiperStore.onChange(index);
  };

  goPrev = () => {
    if (this.activeIndex === 0) {
      this.toSlideWithIndex(MECHA_INFO.length - 1);
      return;
    }
    this.toSlideWithIndex(this.activeIndex - 1);
  };

  goNext = () => {
    if (this.activeIndex === MECHA_INFO.length - 1) {
      this.toSlideWithIndex(0);
      return;
    }
    this.toSlideWithIndex(this.activeIndex + 1);
  };

  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  jumpDetail = id => {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, '?id=' + id);
    } else {
      this.mainStore?.redirect('/mecha-unit?id=' + id);
    }
  };

  use() {
    const funlinkData = useLayerData('part5');

    useEffect(
      () => {
        if (funlinkData) {
          this.mechaList = funlinkData?.mechaList || [];
        }
      },
      [funlinkData]
    );

    useEffect(() => {
      const onResize = () => {
        this.updateDetailBtnPosition(MECHA_INFO[this.activeIndex]);
        this.updateCompleted = false;
      };
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, []);
  }
}
export default FifthPageStore;
